import Header from "../../Home/Header";
import Footer from "../../Home/Footer";

function Horloge () {
  return (
    <div className="core">
      <Header />
      <h2 className="titre bloc">Charles-Quint et la grande horologe</h2>
      <div className="bloc">
        <p>Charles-Quint n’était pas seulement un grand souverain, mais aussi un homme très aidant. Parfois un peu trop.</p>
        <p>Un beau jour, il déambulait dans son palais, richement paré d’œuvres d’art raffinées et de tapisseries sublimes.</p>
        <p>Il pénétra dans la salle où était exposée sa splendide collection d’horloges et vit un homme, juché sur une échelle, prêt à décrocher l’une d’entre elles pour en enlever la poussière.</p>
        <p>L’empereur était un homme maniaque. Les sols de son palais étaient donc parfaits, mais extrêmement glissants. Effrayé à l’idée de voir chuter notre homme sur la tête, son échelle pouvant violemment déraper, Charles-Quint proposa de l’aider. « Pas de souci mon ami », dit-il en saisissant l’échelle à pleines mains pour la bloquer. Charles-Quint trouva l’homme peu reconnaissant car arrivé sur le sol, l’homme prit ses jambes à son cou.</p>
        <p>Quelques heures plus tard, alors qu’il se reposait en dégustant une délicieuse bière, on vint lui apprendre la disparition de l’une de ses plus belles horloges. Charles-Quint porta le pot de bière à ses lèvres et pensa : « Et bien moi, je sais au moins à quelle heure eut lieu le méfait ». Maigre consolation…</p>

      </div>
      <Footer />
    </div>
  )
}
export default Horloge